module.exports = __webpack_public_path__ + "img/change-camera-img.e8ea7f1a.svg";